import { Button, Dialog, InfiniteScroll, TextArea, Toast } from "antd-mobile";
import "./index.less";
import BackToTop from "../../components/BackToTop";
import { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import IconSound from "@/images/icon/icon-sound.png";
import { batchGetDict } from "@/api/common";
import { API_RESULT_CODE, DictOption, DictType } from "@/config/types/common";
import { DialogShowHandler } from "antd-mobile/es/components/dialog";
import queryString from "query-string";
import { getEmailConfig, sendAdvice, getMyAdvice } from "@/api/mailbox";
import AdviceCard from "./components/AdviceCard";
import { AdviceItem } from "@/config/types/mailbox";
import IconEmpty from "@/images/icon/icon-empty.png";

const PAGE_SIZE = 10;

export enum AdviceType {
  ONLINE = "online", // 在线留言
  MY = "my", // 我的留言
}

const list = [
  {
    key: AdviceType.ONLINE,
    title: "在线留言",
  },
  {
    key: AdviceType.MY,
    title: "我的留言",
  },
];

const TrendAuditMsg = () => {
  const parse = queryString.parse(window.location.search);
  const handler = useRef<DialogShowHandler>();
  const [activeTab, setActiveTab] = useState<"online" | "my">("online");
  const [adviceTypeOption, setAdviceTypeOption] = useState<DictOption[]>([]);
  const [adviceType, setAdviceType] = useState<string>("");
  const [emailHint, setEmailHint] = useState<string>(""); // 意见类型
  const [adviceDesc, setAdviceDesc] = useState<string>(""); //意见说明
  const [loading, setLoading] = useState<boolean>(false); // 提交loading
  const [dataList, setDataList] = useState<any[]>([]);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);

  useEffect(() => {
    const tab = parse?.activeTab as string;
    if ([AdviceType.ONLINE, AdviceType.MY].includes(tab as AdviceType)) {
      setActiveTab(tab as AdviceType | AdviceType.MY);
    }
  }, []);

  const getConfig = async () => {
    try {
      const { code, data, msg } = await getEmailConfig();
      if (code === API_RESULT_CODE.SUCCESS) {
        const { emailHint } = data;
        setEmailHint(emailHint);
      } else {
        Toast.show(msg || "提示语获取失败，请稍后再试");
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getConfig();
    // 获取字典项
    getDict();
  }, []);
  const getDict = () => {
    // DictType.PROPERTY_ONCALL,
    batchGetDict([DictType.ADVICE_TYPE]).then((result: any) => {
      if (result.code === API_RESULT_CODE.SUCCESS) {
        const {
          // [DictType.PROPERTY_ONCALL]: serviceMobile,
          [DictType.ADVICE_TYPE]: adviceTypeOption,
        } = result?.data || {};

        // setServiceMobile(serviceMobile);
        setAdviceTypeOption(adviceTypeOption || []);
        setAdviceType((adviceTypeOption || [])?.[0]?.value); // 默认选中第一个
      }
    });
  };

  const handleChangeTab = (item: any) => {
    setActiveTab(item.key);
    if (item.key === AdviceType.MY) {
      // 重置分页状态
      setPage(1);
      setDataList([]);
      setHasMore(true);
      // 重新加载数据，不然在左侧tab新增意见时，此tab不会立即更新
      loadMore({ pageNum: 1 });
    }
  };
  const handleChangeType = (item: DictOption) => {
    setAdviceType(item.value as string);
  };
  const handleSubmit = async () => {
    try {
      setLoading(true);
      const { code, msg } = await sendAdvice({ adviceType, adviceDesc });
      setLoading(false);
      if (code === API_RESULT_CODE.SUCCESS) {
        handler.current = Dialog.show({
          content: "您的留言已收悉，我们将在7个工作日内向您反馈",
          bodyClassName: "dialog-content",
          actions: [
            {
              key: "submit",
              text: "我知道了",
              className: "dialog-submit-btn",
              onClick: () => {
                handler.current?.close();
                // 清除意见说明
                setAdviceDesc("");
              },
            },
          ],
        });
      } else {
        setLoading(false);
        Toast.show(msg || "提交失败，请稍后再试");
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  async function loadMore(params: any = {}) {
    try {
      const { code, data, msg } = await getMyAdvice({
        pageNum: page,
        pageSize: PAGE_SIZE,
        ...params,
      });
      if (code === API_RESULT_CODE.SUCCESS) {
        const list = data?.list || [];
        const { current, total } = data || {};
        if (current === 1) {
          setDataList(list || []);
        } else {
          setDataList((val: any) => [...val, ...(list || [])]);
        }
        setPage(current + 1);
        setHasMore(current * PAGE_SIZE < total);
      } else {
        setHasMore(false);
        Toast.show(msg || "我的留言获取失败，请稍后再试");
      }
    } catch (error) {
      setHasMore(false);
      throw new Error("我的留言获取失败");
    }
  }

  return (
    <div className="mailbox-page">
      <div className="mailbox-container">
        <div className="mailbox-top">
          {list.map((item: any) => (
            <div
              className={classNames({ item, "active-item": item.key === activeTab })}
              key={item.key}
              onClick={() => handleChangeTab(item)}
            >
              {item.title}
            </div>
          ))}
        </div>
        {activeTab === "online" ? (
          <>
            {emailHint && (
              <div className="mailbox-tips">
                <img src={IconSound} alt="" className="icon-sound" />
                <span>{emailHint}</span>
              </div>
            )}

            <div className="section">
              <div className="section-title">选择意见类型</div>
              <div className="suggest-wrap">
                {adviceTypeOption.map((item: DictOption) => (
                  <div
                    className={classNames({ item, "type-active": item.value === adviceType })}
                    key={item.value}
                    onClick={() => handleChangeType(item)}
                  >
                    {item.label}
                  </div>
                ))}
              </div>

              <div className="section-title suggest-title">意见说明</div>
              <TextArea
                placeholder="期待您的宝贵意见"
                showCount
                maxLength={500}
                rows={7}
                className="textarea"
                value={adviceDesc}
                onChange={(val: any) => {
                  setAdviceDesc(val);
                }}
              />
            </div>
            <div className="btn-wrap">
              <Button className="submit-btn" onClick={handleSubmit} loading={loading}>
                提交
              </Button>
            </div>
          </>
        ) : (
          <div className="my-mailbox">
            {Array.isArray(dataList) && dataList.length > 0 ? (
              <>
                {dataList.map((item: AdviceItem, index: number) => (
                  <AdviceCard info={item} key={index} />
                ))}
                <InfiniteScroll loadMore={loadMore} hasMore={hasMore} />
              </>
            ) : (
              <div className="empty-box">
                <img src={IconEmpty} alt="暂无留言" className="icon-empty" />
                <div className="empty-desc">暂无留言</div>
              </div>
            )}
          </div>
        )}
      </div>
      <BackToTop />
    </div>
  );
};

export default TrendAuditMsg;
